import { Accordion, type IAccordionItemClickEvent, type TAccordionSize, type TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import type { TFaqItem } from 'shared/types/faq';

import { Block } from './components/Block';
import * as styles from './styles.css';

interface IFaqProps {
  device: TDeviceType;
  title: string;
  accordionSize: TAccordionSize;
  items: TFaqItem[];
  compactTop?: boolean;
  onItemClick: (event: IAccordionItemClickEvent) => void;
  getLinkClickHandler: (questionId: number, question: string) => ((link: string) => void) | undefined;
}

export const Faq: React.FC<IFaqProps> = ({
  device,
  title,
  accordionSize,
  items,
  compactTop,
  onItemClick,
  getLinkClickHandler,
}) => {
  return (
    <div className={clsx(styles['container'], styles[device], compactTop && styles['compact-top'])}>
      <div className={styles['title']}>{title}</div>
      <Accordion
        size={accordionSize}
        onItemClick={onItemClick}
        items={items.map((item, index) => ({
          title: item.title,
          content: item.content.map((contentArray, contentIndex) => (
            <Block key={contentIndex} content={contentArray} onLinkClick={getLinkClickHandler(index + 1, item.title)} />
          )),
          key: index,
        }))}
      />
    </div>
  );
};
